/**
 * @file Created on Wed Aug 08 2018
 * @author PKl
 */
import Badge from './Badge';
export default Badge;
export { BadgeType } from './BadgeType';